export const normalizeEventDetail = (rawData) => {
  if (!rawData) {
    return {}
  }
  return {
    eventId: rawData?.eventid,
    content: rawData?.content,
    eventType: rawData?.event_type,
    eventTitle: rawData?.eventtitle,
    description: rawData?.description,
    status: rawData?.status,
    startDate: rawData?.startdate,
    endDate: rawData?.enddate,
    announcementDate: rawData?.announcementdate,
    gift: rawData?.gift,
    landingUrl: rawData?.landing_url,
    listImage: rawData?.listimage,
    detailImage: rawData?.detailimage,
  }
}
